import {ExclamationCircleOutlined} from '@ant-design/icons';
import {Button, Modal} from '@ds/components';

type DealDetailActionModalProps = {
  isOpen: boolean;
  isActive: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const DealDetailActionModal: React.FC<DealDetailActionModalProps> = ({
  isOpen,
  isActive,
  onClose,
  onConfirm
}) => {
  return (
    <Modal show={isOpen} onClose={onClose}>
      <div className="flex flex-col items-center px-6 py-6 text-center">
        <ExclamationCircleOutlined className="mb-4 text-subtitle-lg text-destructive" aria-hidden />
        <h3 className="mb-4 text-subtitle-md text-neutral-fg">{isActive ? 'توقف تخفیف؟' : 'حذف تخفیف؟'}</h3>
        <p className="mb-6 text-body-sm text-gray-07">
          {isActive
            ? 'امکان بازگرداندن تخفیف در صورت توقف آن وجود نخواهد داشت.'
            : 'امکان بازگرداندن تخفیف در صورت حذف آن وجود نخواهد داشت.'}
        </p>
        <div className="flex w-full flex-col gap-2">
          <Button color="destructive" fullWidth size="lg" onClick={onConfirm}>
            {isActive ? 'توقف' : 'حذف'}
          </Button>
          <Button fullWidth variant="ghost" size="lg" onClick={onClose}>
            انصراف
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DealDetailActionModal;
